import { useParams } from "react-router-dom";

const useTabId = () => {
  const { tabId } = useParams();

  return Number(tabId);
};

export default useTabId;
